// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextareaShallow__textarea--2K9","noResize":"TextareaShallow__noResize--2_T"};